import api from "@/lib/api";
import { AI_BG_PRESET_KEY } from "@/components/AiBgPresetSelector";

/** Egy kérés ≤ ~15 perc nginx alatt; 4 kép × ~2 perc tipikusan belefér. */
const AI_BG_BATCH = 4;
const AI_BG_TIMEOUT_MS = 900_000;

/** Összes galéria kép — batch-ekben /ai-bg (backend merge, max 32 kép). */
export async function runAiBgOnCarImages(
  carId,
  imageUrls,
  preset = AI_BG_PRESET_KEY,
  { fromOriginal = false, onProgress } = {},
) {
  const urls = (imageUrls || []).filter(Boolean);
  if (!urls.length) {
    throw new Error("Nincs feltöltött kép");
  }

  if (fromOriginal) {
    const r = await api.post(
      `/my/cars/${carId}/ai-bg`,
      { image_urls: urls, preset, from_original: true },
      { timeout: AI_BG_TIMEOUT_MS },
    );
    onProgress?.({ done: urls.length, total: urls.length });
    return { ...r.data, originals: urls };
  }

  let merged = [...urls];
  let processedTotal = 0;
  const total = urls.length;

  for (let i = 0; i < total; i += AI_BG_BATCH) {
    const batch = urls.slice(i, i + AI_BG_BATCH);
    const r = await api.post(
      `/my/cars/${carId}/ai-bg`,
      {
        image_urls: batch,
        preset,
        merge_gallery: merged,
      },
      { timeout: AI_BG_TIMEOUT_MS },
    );
    merged = r.data.images || merged;
    processedTotal += r.data.processed ?? batch.length;
    onProgress?.({ done: Math.min(i + batch.length, total), total });
  }

  return {
    images: merged,
    processed: processedTotal,
    preset,
    originals: urls,
  };
}
